import logoAccent from 'assets/logo-accent.svg';
import logoDark from 'assets/logo-dark.svg';
import logoLight from 'assets/logo-light.svg';
import { Logo } from 'components/common/Logo';
import { DEFAULT_AUTH_BRAND } from 'constants/authBrand';
import { useTheme } from 'contexts/ThemeContext';

/** Light brand panel shown beside the auth forms (design: left column). */
export function AuthBrandPanel({ pre, accent, post, subtitle } = DEFAULT_AUTH_BRAND) {
  const { isDark } = useTheme();
  return (
    <div
      className="relative hidden flex-col justify-between overflow-hidden p-14 lg:flex"
      style={{ backgroundImage: 'linear-gradient(150deg, var(--an-panel-a), var(--an-panel-b))' }}
    >
      <span className="relative z-10">
        <Logo variant={isDark ? 'light' : 'dark'} size={24} />
      </span>

      <div className="relative z-10 max-w-[400px]">
        <h1 className="font-serif text-[52px] font-semibold leading-[1.04] tracking-[-0.018em] text-ink [text-wrap:balance]">
          {pre}
          <span className="text-brand">{accent}</span>
          {post}
        </h1>
        <p className="mt-6 max-w-[27rem] text-[15.5px] leading-relaxed text-slate">{subtitle}</p>
      </div>

      <div className="relative z-10 text-[12.5px] text-silver">
        © {new Date().getFullYear()} Anablr
      </div>

      {/* Bottom watermark: the wordmark stays a faint ghost, but its coral
          accent triangle is a second, exactly-aligned layer (same viewBox)
          shown at full brand colour and full opacity — a deliberate spot of
          colour rather than a washed-out artifact. */}
      <div className="pointer-events-none absolute inset-x-0 bottom-0 z-0 w-full select-none">
        <img
          src={isDark ? logoLight : logoDark}
          alt=""
          aria-hidden="true"
          draggable={false}
          className="block w-full opacity-[0.05]"
        />
        <img
          src={logoAccent}
          alt=""
          aria-hidden="true"
          draggable={false}
          className="absolute inset-0 block w-full"
        />
      </div>
    </div>
  );
}

export default AuthBrandPanel;
